var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgraLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 665,
    viewBox: "0 0 1440 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_1476_694)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1476_694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -85,
    y: 0,
    width: 1604,
    height: 899
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1518.92 0H-85V898.852H1518.92V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1476_694)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1476_694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -77,
    y: -1,
    width: 1599,
    height: 901
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1521.59 -0.777161H-76.9355V899.629H1521.59V-0.777161Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1476_694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.959 -385.988C310.006 -385.988 -21.0742 -55.4536 -21.0742 350.829C-21.0742 740.581 283.624 1060.57 667.69 1085.97L657.758 1042.22C302.102 1012.13 21.8829 713.558 21.8829 350.828C21.8829 -31.8073 333.693 -343.109 716.96 -343.109C1100.23 -343.109 1412.04 -31.8091 1412.04 350.828C1412.04 606.636 1272.66 830.532 1065.75 950.873L1053.98 1006.23C1291.91 883.789 1455 635.971 1455 350.831C1455 -55.4531 1123.91 -385.986 716.961 -385.986",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.604 574.791L662.564 637.253C734.674 684.663 782.396 766.168 782.396 858.632C782.396 927.924 755.584 991.055 711.814 1038.31L756.782 1065.02C804.731 1009.57 833.829 937.452 833.829 858.632C833.829 734.227 761.479 626.408 656.604 574.791Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.256 451.287L587.955 503.826C753.936 536.848 879.423 683.363 879.423 858.632C879.423 945.697 848.45 1025.67 796.941 1088.16C802.366 1089.28 814.925 1089.73 843.686 1084.6C851.456 1083.22 858.997 1081.68 866.232 1080.1C907.129 1016.05 930.858 940.058 930.858 858.632C930.858 654.365 781.602 484.277 586.256 451.287Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.264 1039.82C994.264 1039.82 1003.42 1016.02 1009.46 989.461C1015.51 962.9 1024.45 931.996 1026.67 887.395C1028.54 849.711 1026.66 819.804 1025.9 809.927C1025.76 809.707 1025.62 809.493 1025.49 809.27C1020.54 758 1007.95 708.932 988.872 663.203C995.152 517.23 1120.25 401.478 1269.84 410.228C1273.85 410.461 1277.83 410.799 1281.79 411.211L1297.96 361.463C1287.76 360.037 1277.41 359.093 1266.92 358.673C1116.93 352.665 988.676 451.432 949.503 587.456V587.458C939.498 571.611 928.653 556.349 917.014 541.737C970.209 407.856 1101.14 312.893 1253.96 312.893C1273.79 312.893 1293.23 314.553 1312.21 317.629L1328.27 268.23C1304.15 263.846 1279.32 261.542 1253.96 261.542C1088.51 261.542 945.464 358.977 879.283 499.374C868.113 488.148 856.415 477.444 844.249 467.287C902.748 352.581 1008.19 265.613 1135.12 231.643L1105.59 186.682C974.689 226.436 865.863 317.297 802.633 435.951C721.049 380.827 622.732 348.602 517.02 348.602C427.85 348.602 343.958 371.553 270.918 411.811L291.028 459.404C357.799 421.583 434.924 399.952 517.02 399.952C770.352 399.952 976.459 605.717 976.459 858.63C976.459 932.227 958.98 1001.81 927.988 1063.52C929.68 1062.97 930.678 1062.63 930.678 1062.63L994.264 1039.82V1039.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.17 674.703C1034.17 715.527 1045.44 753.762 1064.97 786.533L1098.57 739.321C1090.23 719.416 1085.61 697.591 1085.61 674.703C1085.61 598.267 1137.01 533.627 1207.1 513.312L1213.01 459.164C1111.33 478.376 1034.17 567.689 1034.17 674.703Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.572 353.475C456.028 216.225 570.811 107.431 710.647 107.431C818.036 107.431 910.625 171.617 952.125 263.547C966.061 253.323 980.526 243.79 995.48 234.991C944.347 129.292 835.884 56.1974 710.647 56.1974C539.168 56.1974 399.235 193.263 394.76 363.402C411.716 359.229 429.003 355.905 446.572 353.475Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.645 249.504C649.231 249.504 598.246 294.868 589.508 353.794C606.626 356.233 623.463 359.533 639.996 363.63C644.064 328.286 674.174 300.738 710.645 300.738C749.881 300.738 781.801 332.605 781.801 371.777C781.801 387.732 776.441 402.426 767.509 414.298C779.514 421.07 791.251 428.263 802.628 435.95C811.542 419.226 821.411 403.087 832.068 387.529C832.736 382.367 833.119 377.116 833.119 371.777C833.119 304.353 778.178 249.504 710.645 249.504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.647 152.85C597.368 152.85 503.878 239.052 492.523 349.199C500.641 348.814 508.805 348.602 517.017 348.602C526.148 348.602 535.203 348.928 544.22 349.404C555.214 267.485 625.635 204.084 710.647 204.084C790.236 204.084 857.028 259.657 874.257 333.962C887.162 319.639 900.859 306.046 915.292 293.256C883.604 211.227 803.847 152.85 710.647 152.85Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.646 -40.4589C482.965 -40.4589 297.732 144.468 297.732 371.777C297.732 380.467 298.037 389.089 298.568 397.649C314.98 389.866 331.871 382.938 349.18 376.91C349.158 375.194 349.051 373.498 349.051 371.777C349.051 172.72 511.261 10.7752 710.646 10.7752C853.266 10.7752 976.828 93.6538 1035.65 213.683C1051.08 206.368 1066.93 199.803 1083.17 194.035C1016.56 55.4564 874.617 -40.4589 710.646 -40.4589Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.016 -156.043L404.837 -150.976C259.368 -65.8293 152.405 78.0672 116.895 247.861L161.463 290.103C192.709 79.7782 342.715 -92.3733 541.016 -156.043Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.516 386.845C252.351 381.84 252.237 376.823 252.237 371.778C252.237 123.054 452.018 -79.957 699.783 -85.7398L637.721 -131.883C404.903 -98.4351 222.438 92.6604 202.719 329.205L212.249 338.237L252.516 386.845Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.85 -26.1937C964.198 -76.8773 888.202 -112.718 805.118 -128.328L769.953 -81.9877C855.103 -70.9534 932.985 -36.532 996.901 14.6407L1027.85 -26.1937Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.09 570.836C1224.82 624.414 1193.37 673.957 1154.96 717.548L1194.21 750.466C1240.62 697.595 1277.78 636.813 1303.63 570.836H1248.09Z",
    fill: "#F0F0F0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1476_694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 665,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgraLogoSvg);
export default __webpack_public_path__ + "static/media/agra_logo_svg.1db91072c6ea19c1549d8bc7ccee2a1e.svg";
export { ForwardRef as ReactComponent };